import { Options } from 'react-pdf/dist/esm/shared/types.js';

export const OPTIONS: Options = {
  withCredentials: true,
};
